import { defineStore } from 'pinia'


export const useHomeStore = defineStore('home', {
  state: () => ({
    content: null,
  }),

  
  actions: {
    async loadContent(locale) {
      console.log('Начинаем загрузку контента.')
      console.log('Текущая локаль:', locale)

      if (!locale) {
        console.error('Локаль не определена.')
        return
      }

      try {
        const response = await fetch(`/data/home/${locale}.json`)
        if (!response.ok) {
          throw new Error('Ошибка загрузки данных')
        }
        const data = await response.json()
        console.log('Данные успешно загружены', data)
        this.content = data
        console.log('Контент успешно установлен в хранилище:', this.content)
      } catch (error) {
        console.error('Ошибка загрузки данных:', error)
        console.error(`Путь к файлу: /data/home/${locale}.json`)
      }
    }
  }
})
